module.exports = __webpack_public_path__ + "assets/img/number_times_item4.b5685dc6.png";